<template>
  <button
    :class="cl(
      'o-button',
      type,
      size,
      sharp,
      disabled,
      bold,
      bolder
    )"
    :disabled="disabled"
    :type="nativeType"
    @click="$emit('click')"
  >
    <span class="o-button__text"><slot></slot></span>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      validator(value) {
        return ['default', 'primary', 'danger', 'text', 'icon'].indexOf(value) !== -1;
      },
      default: 'default',
    },
    size: {
      validator(value) {
        return ['default', 'large', 'small', 'mini'].indexOf(value) !== -1;
      },
      default: 'default',
    },
    sharp: Boolean,
    disabled: Boolean,
    bold: Boolean,
    bolder: Boolean,
    nativeType: {
      validator(value) {
        return ['submit', 'button', 'reset'].indexOf(value) !== -1;
      },
      default: 'button',
    },
  },

  methods: {
    cl(
      block,
      type,
      size,
      sharp,
      disabled,
      bold,
      bolder,
    ) {
      const result = [block];
      if (type !== 'default') result.push(`${block}--${type}`);
      if (size !== 'default') result.push(`${block}--${size}`);
      if (bold) result.push(`${block}--bold`);
      if (bolder) result.push(`${block}--bolder`);
      if (sharp) result.push(`${block}--sharp`);
      if (disabled) result.push(`${block}--disabled`);
      return result.join(' ');
    },
  },
};
</script>

<style lang="less">
@import "../assets/styles/variable";
@import "../assets/styles/mixins";

.o-button {
  position: relative;
  display: inline-block;
  width: 32px;
  line-height: 32px;
  border-radius: 18px;
  font-size: 16px;
  box-sizing: border-box;
  text-align: center;
  user-select: none;
  -webkit-appearance: none;
  z-index: 1000;

  transition: all .25s;
  cursor: pointer;

  &:hover {
    .brightness;
  }

  &:focus {
    outline: none;
  }

  &::before {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    width: 100%;
    height: 100%;
    border: inherit;
    border-color: @black;
    background-color: @black;
    border-radius: inherit;
    transform: translate(-50%, -50%);
  }

  &:active::before {
    opacity: .3;
  }

  // &--default {
  // }

  &--primary {
    color: @button-primary-color;
    background-color: @button-primary-background-color;
    border: 2px solid @button-primary-border-color;
  }

  &--text,
  &--icon {
    background-color: transparent;
    border: none;
    &::before {
      display: none;
    }
  }

  &--danger {
    color: @button-danger-color;
    background-color: @button-danger-background-color;
    border: 2px solid @button-danger-border-color;
  }

  &--large {
    height: 62px;
    font-size: 18px;
    line-height: 60px;
    border-radius: 16px;
  }

  // &--small {
  // }

  &--mini {
    padding: 0 16px;
    height: 32px;
    font-size: 17px;
    line-height: 32px;
    border-radius: 4px;
  }

  &--icon {
    min-width: 20px;
    padding: 0 3px;
  }

  &--bold {
    font-weight: 500;
  }

  &--bolder {
    font-weight: 600;
  }

  &--sharp {
    border-radius: 0px;
  }

  &--disabled {
    color: @button-disabled-color;
    filter: brightness(0.7) !important;
    cursor: not-allowed;
    &:active::before {
      opacity: 0;
    }
  }
}
</style>
